// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ft-0";
export var fileCarousel = "_ft-2";
export var removeFileButton = "_ft-1";